import React from 'react';
import { InventoryHealthStats } from '../../../../types/inventoryHealth';
import { ShieldCheck, AlertCircle, AlertTriangle, Activity } from 'lucide-react';

interface HealthMetricCardsProps {
  stats: InventoryHealthStats;
}

export const HealthMetricCards: React.FC<HealthMetricCardsProps> = ({ stats }) => {
  const scoreColor =
    stats.averageHealthScore >= 80
      ? 'text-emerald-600 bg-emerald-50 border-emerald-200'
      : stats.averageHealthScore >= 60
      ? 'text-amber-600 bg-amber-50 border-amber-200'
      : 'text-rose-600 bg-rose-50 border-rose-200';

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-6">
      <div id="metric-card-score" className="col-span-2 lg:col-span-1 p-4 rounded-2xl bg-white border border-gray-100 shadow-sm flex flex-col justify-between">
        <div className="flex items-center justify-between">
          <span className="text-xs font-black uppercase tracking-wider text-gray-400">Salud General</span>
          <Activity className="w-4 h-4 text-sky-600" />
        </div>
        <div className="mt-3 flex items-baseline gap-2">
          <span className={`text-3xl font-black px-2.5 py-0.5 rounded-xl border ${scoreColor}`}>
            {stats.averageHealthScore}%
          </span>
          <span className="text-xs font-bold text-gray-500">Promedio</span>
        </div>
      </div>

      <div id="metric-card-total" className="p-4 rounded-2xl bg-white border border-gray-100 shadow-sm flex flex-col justify-between">
        <span className="text-xs font-black uppercase tracking-wider text-gray-400">Total Activos</span>
        <div className="mt-3">
          <span className="text-2xl font-black text-gray-800">{stats.totalActive}</span>
          <p className="text-[11px] text-gray-400 font-medium mt-0.5">Inmuebles 183150</p>
        </div>
      </div>

      <div id="metric-card-healthy" className="p-4 rounded-2xl bg-white border border-gray-100 shadow-sm flex flex-col justify-between">
        <div className="flex items-center justify-between">
          <span className="text-xs font-black uppercase tracking-wider text-emerald-600">100% Sanos</span>
          <ShieldCheck className="w-4 h-4 text-emerald-600" />
        </div>
        <div className="mt-3">
          <span className="text-2xl font-black text-emerald-700">{stats.healthyCount}</span>
          <p className="text-[11px] text-emerald-600/80 font-medium mt-0.5">
            {stats.totalActive > 0 ? Math.round((stats.healthyCount / stats.totalActive) * 100) : 0}% sin observaciones
          </p>
        </div>
      </div>

      <div id="metric-card-critical" className="p-4 rounded-2xl bg-white border border-gray-100 shadow-sm flex flex-col justify-between">
        <div className="flex items-center justify-between">
          <span className="text-xs font-black uppercase tracking-wider text-rose-600">Críticos</span>
          <AlertCircle className="w-4 h-4 text-rose-600" />
        </div>
        <div className="mt-3">
          <span className="text-2xl font-black text-rose-700">{stats.criticalCount}</span>
          <p className="text-[11px] text-rose-600/80 font-medium mt-0.5">Requieren corrección inmediata</p>
        </div>
      </div>

      <div id="metric-card-warnings" className="p-4 rounded-2xl bg-white border border-gray-100 shadow-sm flex flex-col justify-between">
        <div className="flex items-center justify-between">
          <span className="text-xs font-black uppercase tracking-wider text-amber-600">Advertencias</span>
          <AlertTriangle className="w-4 h-4 text-amber-600" />
        </div>
        <div className="mt-3">
          <span className="text-2xl font-black text-amber-700">{stats.warningCount}</span>
          <p className="text-[11px] text-amber-600/80 font-medium mt-0.5">Detalles por verificar</p>
        </div>
      </div>
    </div>
  );
};
